'use client';

import FaIcon, { faChevronRight } from '../../../../components/icon/FaIcon/FaIcon';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import type { ContactHeaderSideNodeProps } from '../../types';
import styles from './ContactHeaderSideNode.module.scss';

export interface ContactHeaderSideNodeUIProps extends Omit<ContactHeaderSideNodeProps, 'FaIconComponent'> {
  onNavigate: (path: string) => void;
}

function ContactHeaderSideNode({ redirectPath, onNavigate }: ContactHeaderSideNodeUIProps) {
  const currentStyles = styles;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onNavigate(redirectPath);
  };

  return (
    // biome-ignore lint/a11y/useValidAnchor: <explanation>
    <a href='#' className={`${utilsStyles.textSmall} ${currentStyles.linkListItem}`} onClick={handleClick}>
      <div className={currentStyles.linkListItem}>
        返信一覧 &nbsp;
        <FaIcon icon={faChevronRight} size='sm' />
      </div>
    </a>
  );
}

export default ContactHeaderSideNode;
